import React, { useMemo } from 'react'
import Box from '@cloudscape-design/components/box'
import { getToolUrl } from '@services/ToolMenuConfigService'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

/**
 * PromotionsView — embeds the Promotions page (JWOStoreManagementPromotionsWebsite) as an iframe filling
 * the tab panel. Mirrors OrdersView.
 *
 * PROMOTIONS_ASSET_ID must equal ASSET_ID in JwoPromotionsTool.constants.ts
 * (JWOStoreManagementPlatformRegistration) and the TOOL_ID the website passes to
 * PlatformClient.init; PROMOTIONS_DISPLAY_NAME must equal its registered display name, because
 * getToolUrl resolves the URL from it. Locally the URL is overridden to the promotions dev server
 * via local.dev.config.ts toolOverrides.
 */
export const PROMOTIONS_DISPLAY_NAME = 'Promotions'
export const PROMOTIONS_ASSET_ID = 'jwo-promotions-app'

/** The registered URL with any hash removed; the Promotions page has no hash route. '' if unresolved. */
export const buildPromotionsUrl = (): string => {
    const base = getToolUrl(PROMOTIONS_DISPLAY_NAME, PROMOTIONS_ASSET_ID)
    if (!base) {
        console.warn('OperationsPage: could not resolve Promotions URL')
        return ''
    }
    const hashIndex = base.indexOf('#')
    return hashIndex !== -1 ? base.substring(0, hashIndex) : base
}

const PromotionsView: React.FC = () => {
    const [bundle] = useBundle(BUNDLE_NAME)
    const promotionsUrl = useMemo(() => buildPromotionsUrl(), [])

    if (!promotionsUrl) {
        return (
            <Box padding="l" color="text-status-inactive">
                {t(bundle, 'jsma-web-operations-promotionsUnavailable')}
            </Box>
        )
    }

    return (
        <div className="operations-embedded-container" data-atb-id="operations-promotions-container">
            <iframe
                className="operations-embedded-frame"
                data-atb-id="operations-promotions-frame"
                title={t(bundle, 'jsma-web-operations-promotionsTitle')}
                aria-label={t(bundle, 'jsma-web-operations-promotionsTitle')}
                src={promotionsUrl}
            />
        </div>
    )
}

export default PromotionsView
